export const REFERRAL_OPTIONS = ["Google", "Instagram", "Facebook", "TikTok", "Referral", "Word of Mouth", "Other"];

export const SERVICES = [
  { id: "website", title: "Website Development", badge: "Most Popular", description: "Professional websites designed to turn visitors into customers.", featured: true },
  { id: "graphic-design", title: "Graphic Design", description: "Logos, branding, promotional graphics and more." },
  { id: "video-editing", title: "Video Editing", description: "Professional editing for social media, businesses and creative projects." },
  { id: "ai-video", title: "AI Video Creation", description: "AI-powered video content and creative visuals." },
  { id: "social-media", title: "Social Media Management", description: "Content management and social media growth support." },
  { id: "meta-marketing", title: "Meta Marketing", description: "Facebook and Instagram advertising campaigns." },
  { id: "multiple", title: "Multiple Services", description: "Need more than one service? Select this option." },
  { id: "not-sure", title: "I'm Not Sure", description: "Tell us what you're trying to accomplish and we'll help determine the right solution." },
];

export const GOALS = [
  "Get More Customers",
  "Build My Brand",
  "Improve My Online Presence",
  "Increase Sales",
  "Create Professional Content",
  "Launch Something New",
  "Other",
];

export const EXISTING_MATERIALS = ["Yes", "No", "Some"];

export const WEBSITE_TYPES = [
  "Brand New Website",
  "Website Redesign",
  "Landing Page",
  "E-Commerce Website",
  "Business Website",
  "Portfolio Website",
  "Booking Website",
  "Other",
];

export const PAGE_COUNTS = ["1–3", "4–6", "7–10", "10+", "Not Sure"];

export const WEBSITE_FEATURES = [
  "Contact Form",
  "Online Booking",
  "E-Commerce",
  "Online Payments",
  "Customer Login",
  "Blog",
  "Gallery",
  "Social Media Integration",
  "Email Marketing",
  "Other",
  "Not Sure",
];

export const CONTENT_NEEDED = ["Yes", "No", "Some of it"];

export const YES_NO = ["Yes", "No"];
export const YES_NO_NOTSURE = ["Yes", "No", "Not Sure"];
export const MEDIA_OPTIONS = ["Yes", "No", "Need M&M Productions to create them"];

export const BUDGETS = ["Under $500", "$500 – $1,000", "$1,000 – $2,500", "$2,500 – $5,000", "$5,000+", "I'm Not Sure Yet"];

export const TIMELINES = ["ASAP", "Within 2 Weeks", "Within 30 Days", "1–3 Months", "3+ Months", "Just Exploring"];

export const CONTACT_PREFS = ["Email", "Phone Call", "Text Message"];

export const CONTACT_TIMES = ["Morning", "Afternoon", "Evening", "Anytime"];
